import { ref, getStorage, getDownloadURL, getMetadata, connectStorageEmulator } from "firebase/storage";
import { getApp } from "firebase/app";

function switchBucket(bucketName) {
  if (process.env.REACT_APP_STAGING === "local") {
    connectStorageEmulator(getStorage(getApp(), bucketName), "localhost", 9199);
  }
  return getStorage(getApp(), bucketName);
}

export async function getFileUrl(storageLocation) {
  const slashIndex = storageLocation.indexOf("/", 12);
  const bucketName = storageLocation.substring(0, slashIndex);
  const fileName   = storageLocation.substring(slashIndex + 1);
  const fileRef = ref(switchBucket(bucketName), fileName);
  const [url, meta] = await Promise.all([getDownloadURL(fileRef), getMetadata(fileRef)]);
  return { url, type: meta.contentType.split("/")[0] };
}
